const ReportChartsStore = {
    printNumberOfPages: null,
    printParametersForSave: null,

    getPrintParametersForSave: function()
    {
        return this.printParametersForSave;
    },

    setPrintParametersForSave: function(printParametersForSave)
    {
        this.printParametersForSave = printParametersForSave;
        $(this).trigger("printParametersForSaveChange");
    },

    getPrintNumberOfPages: function()
    {
        return this.printNumberOfPages;
    },

    setPrintNumberOfPages: function(printNumberOfPages)
    {
        this.printNumberOfPages = printNumberOfPages;
        $(this).trigger("printNumberOfPagesChange");
    }
}

export default ReportChartsStore



// WEBPACK FOOTER //
// ./web/js/reports/charts/ReportChartsStore.js